
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/display",
      function () {
        return require("private-next-pages/display.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/display"])
      });
    }
  